<div class="col-sm-8 col-sm-offset-2">
  <div class="pull-right">
    <app-language-selector></app-language-selector>
  </div>
</div>
<div class="col-sm-8 col-sm-offset-2" *ngIf="!showEmailSent">
  <div *ngIf="!linkExpired" class="alert alert-danger">
    <p><i class="icon">clock</i>{{ appCopy.panelHeader['generateNewLink'+selectedLanguage] }}</p>
  </div>

  <h3 class="text-dark-blue">{{ appCopy.panelHeader['titleStep2'+selectedLanguage] }}</h3>
  <p class="text-dark-blue">{{ appCopy.panelHeader['titleDescriptionStep2'+selectedLanguage] }}</p>

  <form #formValidateEmail="ngForm" name="formValidateEmail" (submit)="handleSubmitValidateEmail(formValidateEmail.value, $event)" novalidate>

    <div class="form-group">
      <input class="form-control" 
              [ngClass]="{ 'has-error' : email.invalid && email.dirty }"
              id="email" 
              name="email" 
              type="email"
              #email="ngModel"
              [(ngModel)]="userEmail"
              [pattern]="emailPattern"
              ngModel
              required>
      <label class="control-label" for="email">{{ appCopy.panelHeader['emailPlaceholder'+selectedLanguage] }}</label>
      <p class="help-block text-danger" *ngIf="email?.errors?.pattern">{{ appCopy.panelHeader['validEmail'+selectedLanguage] }}</p>
      <p class="help-block text-danger" *ngIf="email.invalid && email.dirty && !email?.errors?.pattern">{{ appCopy.panelHeader['warningEmail'+selectedLanguage] }}</p>
    </div>

    <button type="submit" class="btn btn-purple btn-lg btn-block" [disabled]="formValidateEmail.invalid">
      <div class="loader-container-btn" *ngIf="showLoader">
        <div class="loader loader--white">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" />
          </svg>
        </div>
      </div>
      {{ appCopy.panelHeader['btnValidate'+selectedLanguage] }}
    </button>

    <!--<a class="link" href="javascript:void(0)" (click)="goToLogin()">Back to Login</a>-->

  </form>
</div>

<div class="col-sm-8 col-sm-offset-2" *ngIf="showEmailSent">
  <h3>{{ appCopy.panelHeader['title'+selectedLanguage] }}</h3>
  <p class="text-muted">{{ appCopy.panelHeader['titleDescription'+selectedLanguage] }}</p>

  <div class="alert alert-danger">
    <p><i class="icon">clock</i>{{ appCopy.panelHeader['expirationAlert'+selectedLanguage] }}</p>
  </div>

  <p class="text-muted">{{ appCopy.panelHeader['expirationMessage'+selectedLanguage] }}</p>

  <button type="button" class="btn btn-primary btn-ghost btn-lg btn-block margin-top-24" (click)="resendEmail()">{{ appCopy.panelHeader['btnResend'+selectedLanguage] }}</button>
  <hr class="margin-top-24 margin-bottom-8">
  <a class="btn btn-lg btn-black" href="javascript:void(0)" (click)="goToLogin()"><i class="icon">chevron_left_small</i>{{ appCopy.panelHeader['btnBackLogin'+selectedLanguage] }}</a>
</div>